var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"answers-container"},[_c('div',{ref:"answersWrapper",staticClass:"answers-wrapper",style:(_vm.gridStyle)},_vm._l((_vm.answers),function(answer){return _c('answer',_vm._b({key:answer.answerId,ref:"answer",refInFor:true,style:({ fontFamily: _vm.poll.jsStyle.answerFont.name })},'answer',{
          answers: _vm.answers,
          question: _vm.question,
          stats: _vm.stats,
          poll: _vm.poll,
          answer: answer,
          index: _vm.realAnswerIndex(answer),
          answerHeight: _vm.answerHeight
        },false))}),1)])}
var staticRenderFns = []

export { render, staticRenderFns }